import axios from "./_axios";
import { API } from "./apiEndPoints";

export const getAvailableApps = (account_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}`,
  });
  return result;
};
export const updateDirectory = (account_id, payload) => {
  let result = axios()({
    method: "patch",
    url: `${API.ACCOUNTList}${account_id}/`,
    data: payload,
  });
  return result;
};
